/* jk-physics-matter.js (7.12 lib variant): the JKPhysics API of assets/jk-physics.js v2, run on Matter.js 0.20
   (assets/matter.min.js, MIT, ~26 KB gzipped), so the ZZZ hub Listening Station and the cart keep their own code.
   Matter.js is lazy: nothing is fetched until a user calls JKPhysics.load() (the station when it nears the screen,
   the cart once it has CDs). Its URL comes from this script tag's data-matter attribute.

   What Matter does: collision detection, the contact solver (stacking, friction, bounce), integration, and waking a
   sleeping body when something moving hits it. What stays here, because Matter has no equivalent: the pile seen from
   above (stackOverlaps: CDs that already overlap pass over each other), ghost bodies, the fingertip push, the blast,
   pull springs, the held-body spring (with tilt limit and slip), table drag / sliding friction, and when to sleep.

   Same API and units as jk-physics.js v2 (px, seconds, radians; body centres; y grows downwards):
     JKPhysics.load()                     -> Promise, resolves once Matter.js is in (JKPhysics.ready is then true)
     JKPhysics.world(o) / JKPhysics.loop(world, o) / world.add / remove / set / wake / impulse / push / blast / pull /
     release / grab / moveGrab / drop / at / awake / step, world.bounds (live: writes to its fields are picked up),
     body x, y, angle, vx, vy, w, sleeping, fixed, ghost, z, data, target, grab, hw, hh, r, m, aabb(), axes(), contains().
   JKPhysics.version is 2; JKPhysics.lib is 'matter'. */
(function () {
	if (window.JKPhysics) return;
	var tag = document.currentScript, SRC = tag && tag.getAttribute('data-matter'), M = null, loading = null;
	var H = 1 / 60, MS = 1000 / 60, uid = 0, BIG = 20000, THICK = 4000;
	function cross(ax, ay, bx, by) { return ax * by - ay * bx; }

	function load() {
		if (M) return Promise.resolve(api);
		if (!loading) loading = new Promise(function (res, rej) {
			var done = function () { if (!window.Matter) return rej(new Error('Matter.js missing')); M = window.Matter; patch(); api.ready = true; res(api); };
			if (window.Matter) return done();
			if (!SRC) return rej(new Error('no data-matter URL'));
			var s = document.createElement('script');
			s.src = SRC; s.async = true; s.onload = done; s.onerror = function () { loading = null; rej(new Error('Matter.js failed to load')); };
			document.head.appendChild(s);
		});
		return loading;
	}
	// Matter has no per-pair "skip this contact" hook between detection and solving, so its detector's output is
	// filtered per world (ghosts, CDs stacked on each other, a held CD slipping over the pile).
	function patch() {
		var orig = M.Detector.collisions;
		M.Detector.collisions = function (det) { var cs = orig.apply(this, arguments); return det.jk ? det.jk.filter(cs) : cs; };
	}

	/* ---- a body: the old engine's fields, backed by a Matter body ---- */
	function Body(world, o) {
		this.id = ++uid; this.world = world;
		this.shape = o.shape === 'circle' ? 'circle' : 'box';
		this.restitution = o.restitution == null ? 0.3 : o.restitution;
		this.friction = o.friction == null ? 0.3 : o.friction;
		this.drag = o.drag || 0; this.angularDrag = o.angularDrag == null ? this.drag : o.angularDrag;
		this.mu = o.mu || 0; this.muA = o.muA || 0; this.grab = null; this.target = null;
		this.density = o.density || 1; this.fixed = !!o.fixed; this.ghost = false; this.rest = 0;
		this.z = o.z || 0; this.data = o.data;
		this.r = o.r || 0; this.hw = (o.w || 0) / 2; this.hh = (o.h || 0) / 2;
		if (this.shape === 'circle') this.hw = this.hh = this.r;
		this.build(o.x || 0, o.y || 0, o.angle || 0, 0, 0, 0);
	}
	Body.prototype.build = function (x, y, angle, vx, vy, w) {
		var opt = { angle: angle, restitution: this.restitution, friction: this.friction, frictionStatic: this.friction * 1.5, frictionAir: 1 - Math.exp(-this.drag * H),
			density: this.density / 1000, slop: 0.3, sleepThreshold: Infinity };
		var mb = this.shape === 'circle' ? M.Bodies.circle(x, y, this.r, opt, 48) : M.Bodies.rectangle(x, y, this.hw * 2, this.hh * 2, opt);
		mb.jk = this;
		if (this.mb) M.Composite.remove(this.world.engine.world, this.mb);
		this.mb = mb;
		M.Composite.add(this.world.engine.world, mb);
		if (this.fixed) M.Body.setStatic(mb, true);
		else { M.Body.setVelocity(mb, { x: vx * H, y: vy * H }); M.Body.setAngularVelocity(mb, w * H); }
	};
	var P = Body.prototype;
	Object.defineProperties(P, {
		x: { get: function () { return this.mb.position.x; }, set: function (v) { M.Body.setPosition(this.mb, { x: v, y: this.mb.position.y }); } },
		y: { get: function () { return this.mb.position.y; }, set: function (v) { M.Body.setPosition(this.mb, { x: this.mb.position.x, y: v }); } },
		angle: { get: function () { return this.mb.angle; }, set: function (v) { M.Body.setAngle(this.mb, v); } },
		vx: { get: function () { return this.mb.velocity.x * 60; }, set: function (v) { if (!this.fixed) M.Body.setVelocity(this.mb, { x: v * H, y: this.mb.velocity.y }); } },
		vy: { get: function () { return this.mb.velocity.y * 60; }, set: function (v) { if (!this.fixed) M.Body.setVelocity(this.mb, { x: this.mb.velocity.x, y: v * H }); } },
		w: { get: function () { return this.mb.angularVelocity * 60; }, set: function (v) { if (!this.fixed) M.Body.setAngularVelocity(this.mb, v * H); } },
		sleeping: { get: function () { return this.fixed ? !!this._sl : this.mb.isSleeping; }, set: function (v) { if (this.fixed) { this._sl = !!v; return; } M.Sleeping.set(this.mb, !!v); if (!v) this.rest = 0; } },
		m: { get: function () { return this.fixed ? Infinity : this.mb.mass; } },
		im: { get: function () { return this.fixed ? 0 : this.mb.inverseMass; } },
		// Matter solves contacts with 4x the true moment of inertia (steadier stacks; with the true value a disc resting on
		// the cart floor shivers). Pushes, blasts and the held-body spring use the true value, so a CD turns as before.
		iI: { get: function () { return this.fixed ? 0 : this.mb.inverseInertia * M.Body._inertiaScale; } }
	});
	P.setV = function (vx, vy, w) { M.Body.setVelocity(this.mb, { x: vx * H, y: vy * H }); M.Body.setAngularVelocity(this.mb, w * H); };
	P.axes = function () { var c = Math.cos(this.angle), s = Math.sin(this.angle); return [c, s, -s, c]; };
	P.verts = function () {
		var a = this.axes(), out = [], hw = this.hw, hh = this.hh, x = this.x, y = this.y;
		[[-1, -1], [1, -1], [1, 1], [-1, 1]].forEach(function (k) { out.push([x + a[0] * hw * k[0] + a[2] * hh * k[1], y + a[1] * hw * k[0] + a[3] * hh * k[1]]); });
		return out;
	};
	P.aabb = function () {
		var x = this.x, y = this.y;
		if (this.shape === 'circle') return [x - this.r, y - this.r, x + this.r, y + this.r];
		var a = this.axes(), ex = Math.abs(a[0]) * this.hw + Math.abs(a[2]) * this.hh, ey = Math.abs(a[1]) * this.hw + Math.abs(a[3]) * this.hh;
		return [x - ex, y - ey, x + ex, y + ey];
	};
	P.contains = function (px, py, pad) {
		pad = pad || 0;
		var dx = px - this.x, dy = py - this.y;
		if (this.shape === 'circle') return dx * dx + dy * dy <= (this.r + pad) * (this.r + pad);
		var a = this.axes(), lx = dx * a[0] + dy * a[1], ly = dx * a[2] + dy * a[3];
		return Math.abs(lx) <= this.hw + pad && Math.abs(ly) <= this.hh + pad;
	};

	/* ---- a world ---- */
	function World(o) {
		o = o || {};
		this.g = o.gravity || { x: 0, y: 0 };
		this.iterations = o.iterations || 4;
		this.stackOverlaps = !!o.stackOverlaps;
		this.sleepOn = o.sleep !== false;
		this.bodies = [];
		this.pairs = {}; // 'idA:idB' -> 'stacked' | 'touch'
		this.over = []; // stacked pairs that overlap this step: [upper, lower]
		this.rub = o.rub == null ? (this.stackOverlaps ? 3 : 0) : o.rub;
		this.engine = M.Engine.create({ gravity: { x: this.g.x, y: this.g.y, scale: 1e-6 }, enableSleeping: true,
			positionIterations: Math.max(8, this.iterations + 4), velocityIterations: Math.max(6, this.iterations + 2), constraintIterations: 2 });
		this.engine.detector.jk = this;
		this.walls = null; this._wb = '';
		this.bounds = o.bounds || null;
	}
	var WP = World.prototype;
	/* walls: four static slabs kept just outside world.bounds (which callers may edit in place, e.g. the cart's floor) */
	WP.syncWalls = function () {
		var B = this.bounds, key = B ? [B.x0, B.y0, B.x1, B.y1].join() : '', ew = this.engine.world;
		if (key === this._wb) return;
		this._wb = key;
		if (!B) { if (this.walls) this.walls.forEach(function (w) { M.Composite.remove(ew, w); }); this.walls = null; return; }
		if (!this.walls) {
			var opt = { isStatic: true, restitution: 0.05, friction: 0.4, slop: 0.3 };
			this.walls = [M.Bodies.rectangle(0, 0, THICK, BIG, opt), M.Bodies.rectangle(0, 0, THICK, BIG, opt), M.Bodies.rectangle(0, 0, BIG, THICK, opt), M.Bodies.rectangle(0, 0, BIG, THICK, opt)];
			this.walls.forEach(function (w) { w.jkWall = true; });
			M.Composite.add(ew, this.walls);
		}
		var cx = (B.x0 + B.x1) / 2, cy = (B.y0 + B.y1) / 2, W = this.walls;
		M.Body.setPosition(W[0], { x: B.x0 - THICK / 2, y: cy }); M.Body.setPosition(W[1], { x: B.x1 + THICK / 2, y: cy });
		M.Body.setPosition(W[2], { x: cx, y: B.y0 - THICK / 2 }); M.Body.setPosition(W[3], { x: cx, y: B.y1 + THICK / 2 });
		// a moved wall wakes what rests against it
		this.bodies.forEach(function (b) { if (!b.fixed && b.sleeping) { var bb = b.aabb(); if (bb[0] < B.x0 + 1 || bb[2] > B.x1 - 1 || bb[1] < B.y0 + 1 || bb[3] > B.y1 - 1) b.sleeping = false; } });
	};
	/* the contacts Matter will solve this step */
	WP.filter = function (cs) {
		var out = [], seen = {}, i, self = this;
		this.over = [];
		for (i = 0; i < cs.length; i++) {
			var c = cs[i], ma = c.bodyA.parent || c.bodyA, mbb = c.bodyB.parent || c.bodyB;
			if (ma.jkWall || mbb.jkWall) { out.push(c); continue; }
			var A = ma.jk, B = mbb.jk;
			if (!A || !B) { out.push(c); continue; }
			if (A.ghost || B.ghost) continue;
			var key = A.id < B.id ? A.id + ':' + B.id : B.id + ':' + A.id, state = this.pairs[key];
			seen[key] = 1;
			if (state === 'stacked') { this.over.push(A.z >= B.z ? [A, B] : [B, A]); continue; }
			if (this.stackOverlaps && !A.fixed && !B.fixed && ((A.grab && A.grab.slipping) || (B.grab && B.grab.slipping))) { this.pairs[key] = 'stacked'; continue; }
			if (!state) {
				var thin = Math.min(A.hw, A.hh, B.hw, B.hh);
				if (this.stackOverlaps && c.depth > thin * 0.5) { this.pairs[key] = 'stacked'; continue; }
				this.pairs[key] = 'touch';
			}
			out.push(c);
		}
		// forget pairs that no longer overlap; a stacked pair the detector skipped (both at rest) is kept
		Object.keys(this.pairs).forEach(function (key) {
			if (seen[key]) return;
			if (self.pairs[key] === 'touch') { delete self.pairs[key]; return; }
			var ids = key.split(':'), a = self.byId(+ids[0]), b = self.byId(+ids[1]);
			if (!a || !b || !((a.fixed || a.sleeping) && (b.fixed || b.sleeping))) delete self.pairs[key];
		});
		return out;
	};
	WP.byId = function (id) { for (var i = 0; i < this.bodies.length; i++) if (this.bodies[i].id === id) return this.bodies[i]; return null; };
	WP.add = function (o) { var b = new Body(this, o); this.bodies.push(b); return b; };
	WP.remove = function (b) {
		var i = this.bodies.indexOf(b);
		if (i > -1) { this.bodies.splice(i, 1); M.Composite.remove(this.engine.world, b.mb); }
	};
	WP.set = function (b, o) {
		var x = o.x != null ? o.x : b.x, y = o.y != null ? o.y : b.y, angle = o.angle != null ? o.angle : b.angle;
		var vx = o.still ? 0 : b.vx, vy = o.still ? 0 : b.vy, w = o.still ? 0 : b.w;
		if (o.mu != null) b.mu = o.mu; if (o.muA != null) b.muA = o.muA;
		var resize = (o.w != null && o.w / 2 !== b.hw) || (o.h != null && o.h / 2 !== b.hh) || (o.r != null && o.r !== b.r);
		if (o.r != null) { b.r = o.r; if (b.shape === 'circle') b.hw = b.hh = o.r; }
		if (o.w != null && b.shape === 'box') b.hw = o.w / 2; if (o.h != null && b.shape === 'box') b.hh = o.h / 2;
		var refix = o.fixed != null && !!o.fixed !== b.fixed;
		if (o.fixed != null) b.fixed = !!o.fixed;
		if (resize) b.build(x, y, angle, b.fixed ? 0 : vx, b.fixed ? 0 : vy, b.fixed ? 0 : w);
		else {
			if (refix) { if (b.fixed) { M.Sleeping.set(b.mb, false); M.Body.setStatic(b.mb, true); } else M.Body.setStatic(b.mb, false); }
			M.Body.setPosition(b.mb, { x: x, y: y }); M.Body.setAngle(b.mb, angle);
			if (!b.fixed) b.setV(vx, vy, w);
		}
		this.wake(b);
	};
	WP.wake = function (b) { b.rest = 0; if (!b.fixed && b.mb.isSleeping) M.Sleeping.set(b.mb, false); };
	WP.awake = function () { var n = 0; this.bodies.forEach(function (b) { if (!b.fixed && !b.sleeping) n++; }); return n; };
	WP.at = function (x, y) {
		return this.bodies.filter(function (b) { return b.contains(x, y); }).sort(function (a, b) { return b.z - a.z; });
	};
	WP.impulse = function (b, jx, jy, px, py, soft) {
		if (b.fixed) return;
		this.wake(b);
		var dvx = jx * b.im, dvy = jy * b.im, dw = cross(px - b.x, py - b.y, jx, jy) * b.iI;
		if (soft) { var k = b.kick || (b.kick = { vx: 0, vy: 0, w: 0 }); k.vx += dvx; k.vy += dvy; k.w += dw; return; }
		b.setV(b.vx + dvx, b.vy + dvy, b.w + dw);
	};
	/* A fingertip sliding over the table: the topmost bodies it crosses are dragged towards its velocity at the contact
	   point (so an off-centre touch also turns them). strength: share of the velocity difference taken per call. */
	WP.push = function (x0, y0, x1, y1, vx, vy, o) {
		o = o || {};
		var strength = o.strength == null ? 0.5 : o.strength, max = o.max || 1, filter = o.filter, self = this, hit = [];
		var len = Math.sqrt((x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0)), n = Math.max(1, Math.ceil(len / 8));
		for (var i = 1; i <= n; i++) {
			var px = x0 + (x1 - x0) * i / n, py = y0 + (y1 - y0) * i / n;
			var under = this.at(px, py).filter(function (b) { return !b.fixed && !b.ghost && (!filter || filter(b)); }).slice(0, max);
			under.forEach(function (b) {
				if (hit.indexOf(b) > -1) return; hit.push(b);
				var rx = px - b.x, ry = py - b.y, kk = b.kick || { vx: 0, vy: 0, w: 0 }, bw = b.w + kk.w;
				var dvx = vx - (b.vx + kk.vx - bw * ry), dvy = vy - (b.vy + kk.vy + bw * rx), dl = Math.sqrt(dvx * dvx + dvy * dvy);
				if (dl < 1e-3) return;
				var ux = dvx / dl, uy = dvy / dl, rn = cross(rx, ry, ux, uy), k = b.im + rn * rn * b.iI, J = strength * dl / k;
				self.impulse(b, ux * J, uy * J, px, py, true);
			});
		}
		return hit;
	};
	WP.blast = function (x, y, radius, speed, filter) {
		var self = this;
		this.bodies.forEach(function (b) {
			if (b.fixed || b.ghost || (filter && !filter(b))) return;
			var dx = b.x - x, dy = b.y - y, d = Math.sqrt(dx * dx + dy * dy);
			if (d > radius || d < 1e-3) return;
			var f = speed * (1 - d / radius);
			self.impulse(b, dx / d * f * b.m, dy / d * f * b.m, b.x, b.y, true);
		});
	};
	WP.pull = function (b, t, o) {
		o = o || {};
		b.target = { x: t.x, y: t.y, angle: t.angle, k: o.stiffness || 90, c: o.damping || 16, onArrive: o.onArrive, maxTime: o.maxTime || 0, age: 0 };
		b.ghost = !!o.ghost; this.wake(b);
	};
	WP.release = function (b) { b.target = null; b.ghost = false; };
	WP.grab = function (b, px, py, o) {
		o = o || {};
		var a = b.axes(), dx = px - b.x, dy = py - b.y;
		b.grab = { lx: dx * a[0] + dy * a[1], ly: dx * a[2] + dy * a[3], x: px, y: py, k: o.stiffness || 260, c: o.damping || 24,
			ad: o.angularDamping == null ? 6 : o.angularDamping, a0: b.angle, tilt: o.maxTilt == null ? 0 : o.maxTilt, slip: o.slip || 0, slipping: false };
		this.wake(b);
		return b.grab;
	};
	WP.moveGrab = function (b, x, y) { if (b.grab) { b.grab.x = x; b.grab.y = y; this.wake(b); } };
	WP.drop = function (b, o) {
		if (!b.grab) return;
		b.grab = null; o = o || {};
		var vx = b.vx, vy = b.vy, w = b.w, sp = Math.sqrt(vx * vx + vy * vy);
		if (o.maxSpeed && sp > o.maxSpeed) { vx *= o.maxSpeed / sp; vy *= o.maxSpeed / sp; }
		if (o.maxSpin && Math.abs(w) > o.maxSpin) w = o.maxSpin * Math.sign(w);
		if (!b.fixed) b.setV(vx, vy, w);
		this.wake(b);
	};

	WP.step = function (dt) {
		var bs = this.bodies, i, b;
		this.syncWalls();
		// 0. (lib, Dan 2026-10-01 "more tactile") case-on-case rub: a CD sliding over others drags the ones beneath it a
		// little (rub, 1/s, of the speed difference), and loses a little itself, so a throw rustles the pile it crosses
		if (this.rub) for (i = 0; i < this.over.length; i++) {
			var U = this.over[i][0], L = this.over[i][1];
			if (U.fixed || L.fixed || L.grab || L.target || L.held || U.ghost || L.ghost) continue;
			var rvx = U.vx - L.vx, rvy = U.vy - L.vy, rs = rvx * rvx + rvy * rvy;
			if (rs < 22500) continue; // under 150 px/s: no rub (a resting pile stays asleep)
			var k = Math.min(1, this.rub * dt), mr = U.m / (U.m + L.m);
			this.wake(L);
			L.setV(L.vx + rvx * k * mr, L.vy + rvy * k * mr, L.w);
			if (!U.grab) U.setV(U.vx - rvx * k * (1 - mr) * 0.5, U.vy - rvy * k * (1 - mr) * 0.5, U.w);
		}
		// 1. forces on the velocities (gravity is Matter's: px/s2 x 1e-6 = px/ms2): pull springs, the held-body spring, table drag and sliding friction
		for (i = 0; i < bs.length; i++) {
			b = bs[i]; if (b.fixed || b.sleeping) continue;
			var vx = b.vx, vy = b.vy, w = b.w, x = b.x, y = b.y, ax = 0, ay = 0;
			if (b.target) {
				var t = b.target;
				ax += t.k * (t.x - x) - t.c * vx; ay += t.k * (t.y - y) - t.c * vy;
				if (t.angle != null) { var da = Math.atan2(Math.sin(t.angle - b.angle), Math.cos(t.angle - b.angle)); w += (t.k * da - t.c * w) * dt; }
			}
			vx += ax * dt; vy += ay * dt;
			// drag is Matter's own air friction (frictionAir, set from drag in build: it acts on spin as well); only the
			// extra spin drag beyond it is applied here
			if (b.angularDrag > b.drag) w *= Math.exp(-(b.angularDrag - b.drag) * dt);
			// pushes and blasts arrive as kicks spread over a few steps (45% of what is left per step, ~80 ms), so a
			// fingertip's uneven pointer events move a CD smoothly instead of jolting it on each event
			if (b.kick) { var kk = b.kick; vx += kk.vx * 0.45; vy += kk.vy * 0.45; w += kk.w * 0.45; kk.vx *= 0.55; kk.vy *= 0.55; kk.w *= 0.55; if (Math.abs(kk.vx) + Math.abs(kk.vy) < 2 && Math.abs(kk.w) < 0.02) b.kick = null; }
			if (!b.grab && !b.target) {
				if (b.mu) { var sv = Math.sqrt(vx * vx + vy * vy), dv = b.mu * dt; if (sv <= dv) { vx = vy = 0; } else { vx -= vx / sv * dv; vy -= vy / sv * dv; } }
				if (b.muA) { var aw = Math.abs(w), dw = b.muA * dt; w = aw <= dw ? 0 : w - Math.sign(w) * dw; }
			}
			if (b.grab) {
				// the held-body spring: a soft constraint at the grab point (implicit, stable at any stiffness)
				var g = b.grab, a = b.axes(), rx = a[0] * g.lx + a[2] * g.ly, ry = a[1] * g.lx + a[3] * g.ly, m = b.m, im = b.im, iI = b.iI;
				var kf = m * g.k, cf = m * g.c, gamma = 1 / (dt * (cf + dt * kf)), beta = dt * kf * gamma;
				var cx = x + rx - g.x, cy = y + ry - g.y, vpx = vx - w * ry, vpy = vy + w * rx;
				var k11 = im + iI * ry * ry + gamma, k12 = -iI * rx * ry, k22 = im + iI * rx * rx + gamma, det = k11 * k22 - k12 * k12;
				if (det) {
					var bx = -(vpx + beta * cx), by = -(vpy + beta * cy), jx = (k22 * bx - k12 * by) / det, jy = (k11 * by - k12 * bx) / det;
					vx += jx * im; vy += jy * im; w += cross(rx, ry, jx, jy) * iI;
				}
				if (g.ad) w *= Math.exp(-g.ad * dt);
				if (g.slip) { var gd = Math.sqrt(cx * cx + cy * cy); g.slipping = gd > g.slip || (g.slipping && gd > g.slip * 0.5); }
			}
			b.setV(vx, vy, w);
			b._px = b.mb.position.x; b._py = b.mb.position.y; b._pa = b.mb.angle;
		}
		// 2. Matter: contacts (filtered above), solve, integrate
		M.Engine.update(this.engine, dt * 1000);
		// 3. tilt limit while held, arrivals, and sleep
		for (i = 0; i < bs.length; i++) {
			b = bs[i]; if (b.fixed || b.sleeping) continue;
			if (b.grab) {
				b.rest = 0;
				if (b.grab.tilt) {
					var dg = Math.atan2(Math.sin(b.angle - b.grab.a0), Math.cos(b.angle - b.grab.a0));
					if (Math.abs(dg) > b.grab.tilt) { var bw = b.w; M.Body.setAngle(b.mb, b.grab.a0 + Math.sign(dg) * b.grab.tilt); M.Body.setAngularVelocity(b.mb, bw * dg > 0 ? 0 : bw * H); }
				}
				continue;
			}
			var sp = b.vx * b.vx + b.vy * b.vy;
			if (b.target) {
				var tt = b.target, dd = (tt.x - b.x) * (tt.x - b.x) + (tt.y - b.y) * (tt.y - b.y);
				tt.age += dt;
				if (tt.maxTime && tt.age > tt.maxTime) { var cbt = tt.onArrive; this.release(b); if (cbt) cbt(b, false); continue; }
				if (dd < 0.25 && sp < 25) {
					M.Body.setPosition(b.mb, { x: tt.x, y: tt.y }); if (tt.angle != null) M.Body.setAngle(b.mb, tt.angle); b.setV(0, 0, 0);
					var cb = tt.onArrive; this.release(b); if (cb) cb(b);
				}
				continue;
			}
			if (!this.sleepOn) continue;
			// sleep on what was actually drawn this step: Matter's velocity on a body held still by a contact can read a
			// few px/s that never become motion (a leaning case would otherwise creep and never rest)
			var mx = (b.mb.position.x - b._px) / dt, my = (b.mb.position.y - b._py) / dt, ma = (b.mb.angle - b._pa) / dt;
			if (!b.kick && b._px != null && mx * mx + my * my < 36 && Math.abs(ma) < 0.06) { b.rest += dt; if (b.rest > 0.25) b.sleeping = true; }
			else b.rest = 0;
		}
	};

	/* A fixed-step loop on requestAnimationFrame that runs only while something moves (or active() says so) */
	function loop(world, o) {
		var raf = 0, last = 0, acc = 0;
		function tick(t) {
			raf = 0;
			var dt = last ? Math.min(0.1, (t - last) / 1000) : H; last = t; acc += dt;
			var n = 0; while (acc >= H && n < 4) { world.step(H); acc -= H; n++; } if (n === 4) acc = 0;
			if (o.frame) o.frame(world);
			if (world.awake() || (o.active && o.active())) raf = requestAnimationFrame(tick); else { last = 0; acc = 0; }
		}
		return {
			kick: function () { if (!raf) raf = requestAnimationFrame(tick); },
			stop: function () { if (raf) cancelAnimationFrame(raf); raf = 0; last = 0; acc = 0; },
			get running() { return !!raf; }
		};
	}
	var api = window.JKPhysics = {
		version: 2, lib: 'matter', ready: false, load: load,
		world: function (o) { if (!M) throw new Error('JKPhysics: call load() first'); return new World(o); },
		loop: loop
	};
})();
